import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaUserCircle, FaBars } from "react-icons/fa";
import SearchModal from "./SearchModal";
import "../styles/navbar2.css";
import logo from "../assets/logo8.png";
import { useEffect } from "react";
import Cookies from "js-cookie";

const Navbar1 = () => {

const navigate = useNavigate();
useEffect(() => {
  const handleScroll = () => {
    const navbar = document.querySelector(".custom-navbar");
    if (window.scrollY > 50) {
      navbar.classList.add("scrolled");
    } else {
      navbar.classList.remove("scrolled");
    }
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);
const handleLogout = () => {
    Cookies.remove("access_token");
    Cookies.remove("user_id");
    // remove other cookies if needed
    navigate("/login");
  };

  return (
    <Navbar expand="lg" variant="dark" className="custom-navbar fixed-top">
      <Container fluid>
        <Navbar.Brand as={Link} to="/home" className="custom-logo">
            <img src={logo} alt="Logo" style={{ height: "80px" }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/home">خانه</Nav.Link>
            <Nav.Link as={Link} to="/submit-idea">ثبت ایده</Nav.Link>
            <Nav.Link as={Link} to="#">تماس با ما</Nav.Link>
            <Nav.Link onClick={handleLogout} style={{ cursor: "pointer" }}>خروج</Nav.Link>
          </Nav>
          <div className="d-flex align-items-center gap-2">
            <SearchModal />
            <Button className="profile-btn" as={Link} to={`/dashboard/`}>
              <FaUserCircle />
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navbar1;
